<div class="group-name">
  <div *ngIf="(categoriesArray?.categories?.length ?? 0) > 1" class="inner-addon left-addon searchbar">
    <nb-icon icon="search" pack="icomoon" class="glyphicon"></nb-icon>
    <input
      placeholder="{{ 'view_translations.search' | translate }}"
      class="form-control mb-2 border-0 searchbar-input-field btn-default-color"
      type="search"
      [(ngModel)]="searchInput"
      (input)="searchFilter()" />
  </div>
  <div *ngFor="let element of finalArray; let i = index">
    <!--    <label class="category-element global-transition" [ngClass]="{'category-element-active': hideRuleContent[i]}">-->
    <label class="category-element global-transition" [ngClass]="{'category-element-active': checkIfChecked(element.id)}">
      <input type="checkbox" (change)="checkboxValue($event, i, element)" [checked]="checkIfChecked(element.id)" />
      <div class="element-text" [ngClass]="{'border-radius-top' : (i === 0), 'border-radius-bottom' : (i === finalArray.length-1) }">
        <div>{{ (finalArray.length > 0 || searchInput.trim().length >= 2 ? 'categories.' + element.id : '') | translate }}&nbsp;</div>
        <button
          *ngIf="element.children?.length"
          class="btn show-subelements prevent"
          (click)="toggleExpandable(i)"
          [disabled]="hideRuleContent[i] && countCheckedChildren(element.children)"
          [ngClass]="{'active-button': hideRuleContent[i]}">
          <nb-icon class="show-more-icon" icon="chevron-right" pack="icomoon" [ngClass]="{ 'chevron-active': hideRuleContent[i] }"> </nb-icon>
        </button>
      </div>
      <span class="checkmark global-transition">
        <!-- <nb-icon icon="check" pack="icomoon"></nb-icon> -->
      </span>
    </label>
    <!-- list of subelements -->
    <app-traffic-source-category-subelements
      *ngIf="element.children?.length && hideRuleContent[i]"
      [defaultValue]="defaultValue"
      [element]="element"
      [checkedValues]="checkedValues"
      [endpointParameterCategory]="endpointParameterCategory"
      (emitCheckedFilters)="getCheckedSubelements($event)"
      (emitExpandAction)="setActiveCategoryIndex($event)"
      [nestedSubelements]="false"
      [activeCategory]="i === activeCategoryIndex"
      [isEditMode]="isEditMode">
    </app-traffic-source-category-subelements>
  </div>
  <small *ngIf="isEditMode" class="form-text verification-info"> {{ 'view_translations.re_verifciation_info' | translate }} </small>
  <div
    *ngIf="categoriesArray?.categories?.length && (categoriesArray?.categories?.length ?? 0) > defaultNumberOfCategories && searchInput.length < 2 && !showAllData else noResults"
    class="show-all font500 global-transition"
    [ngClass]="{'show-all-edit' : isEditMode}"
    (click)="showAll()">
    {{ 'view_translations.expand' | translate }} (+{{(categoriesArray?.categories?.length ?? defaultNumberOfCategories) - defaultNumberOfCategories }})
  </div>
  <ng-template #noResults>
    <div class="show-all font500 global-transition" *ngIf="!finalArray.length">{{ 'view_translations.no_results' | translate }}</div>
  </ng-template>
</div>
